<script setup lang="ts">
import { NOOP } from "@vue/shared";
import MPropertyList, { MPropertyRow } from ".";
import MBadge from "../MBadge";
</script>
<template>
  <div style="display: flex; flex-direction: column; gap: 1em">
    <m-property-list title="test" :action="{ label: 'MyAction' }">
      <m-property-row label="Row with a null value" :value="null" />
      <m-property-row label="OPD clinic" value="Test" />
      <m-property-row label="London Clinic">
        <div>Test Slot</div>
      </m-property-row>
      <m-property-row label="Yorkshire clinic" @click="NOOP">
        <div>Click</div>
      </m-property-row>

      <m-property-row label="Golf country clinic" to="#">
        <div>To</div>
      </m-property-row>

      <m-property-row label="badge">
        <div class="flex justify-between">
          <span>Test</span>
          <m-badge text="badge" />
        </div>
      </m-property-row>
      <m-property-row label="action badge" to="#">
        <div class="flex justify-between">
          <span>Test</span>
          <m-badge text="badge" />
        </div>
      </m-property-row>

      <m-property-row
        label="action better badge string"
        :value="`test\nmulti\nline`"
        :badge="{ text: 'Better badge' }"
      />

      <m-property-row
        label="action better array badge string"
        to="#"
        :value="`test\nmulti\nline`"
        :badge="['Better badge', undefined, '2nd badge']"
      />

      <m-property-row
        label="action better array badge mixed"
        to="#"
        :value="`test\nmulti\nline`"
        :badge="['Better badge', { text: 'object', red: true }]"
      />

      <m-property-row presentation-style="vertical-line" to="#">
        <div>
          <p>test</p>
          <p>test</p>
          <p>test</p>
        </div>
      </m-property-row>

      <m-property-row to="#">
        <div>
          <p>test</p>
          <p>test</p>
          <p>test</p>
        </div>
      </m-property-row>

      <m-property-row :value="null" empty-value-text="If null this should show">
        <span>NOT SHOW The value is null </span>
      </m-property-row>

      <m-property-row empty-value-text="If value is not passed this should NOT show">
        <span>Value is not passed </span>
      </m-property-row>
    </m-property-list>

    <m-property-list title="Empty" :action="{ label: 'MyAction' }" />

    <m-property-list empty-text="Custom Empty text">
      <template #title>
        <span> Custom title <i class="fa-light fa-chevron-right" /> </span>
      </template>
      <template #action>
        <span>Custom Action</span>
      </template>
    </m-property-list>

    <m-property-list
      empty-text="Custom Empty text"
      :action="{ label: 'add', actions: [{ label: 'test' }] }"
    >
      <template #title>
        <span> Custom title <i class="fa-light fa-chevron-right" /> </span>
      </template>
    </m-property-list>

    <m-property-list title="Empty List" empty-text="Empty text">
      <m-property-row v-for="i in []" :key="i" />
    </m-property-list>

    <m-property-list class="marked-incorrect" title="Incorrect" empty-text="Empty text">
      <m-property-row v-for="i in []" :key="i" />
    </m-property-list>

    <m-property-list empty-text="No title"> </m-property-list>

    <m-property-list>
      <m-property-row label="No title" value="Test" />
    </m-property-list>

    <m-property-list title="With expanded">
      <m-property-row label="Different icon" icon="fa-solid fa-pen" to="#" />
    </m-property-list>

    <m-property-list title="With expanded - Collapsed">
      <m-property-row label="No title" value="Test" />

      <template #expanded>
        <m-property-row label="Expanded" value="Test" />
      </template>
    </m-property-list>

    <m-property-list title="With expanded - Expanded" expanded>
      <m-property-row label="No title" value="Test" />

      <template #expanded>
        <m-property-row label="Expanded" value="Test" />
        <m-property-row label="Expanded 1" value="Test" />
        <m-property-row label="Expanded 2" value="Test" />
      </template>
    </m-property-list>

    <m-property-list title="With expanded - empty rows" expanded>
      <template #expanded>
        <m-property-row
          presentation-style="vertical-line"
          label="Record Note Created on 28 Apr 2023, 14:00"
          value="Mohammed Lee at Riley House GP Surgery"
        />
        <m-property-row
          presentation-style="vertical-line"
          label="Record Note Created on 28 Apr 2023, 14:00"
          value="Mohammed Lee at Riley House GP Surgery"
        />
      </template>
    </m-property-list>

    <m-property-list title="With expanded - empty rows" expanded>
      <template #expanded>
        <m-property-row
          presentation-style="vertical-line"
          label="Record Note Created on 28 Apr 2023, 14:00"
          value="Mohammed Lee at Riley House GP Surgery"
        />
        <m-property-row
          presentation-style="vertical-line"
          label="Record Note Created on 28 Apr 2023, 14:00"
          value="Mohammed Lee at Riley House GP Surgery"
          to="#"
        />
      </template>
    </m-property-list>

    <m-property-list title="With ">
      <m-property-row
        presentation-style="vertical-line"
        label="Record Note Created on 28 Apr 2023, 14:00"
        value="Mohammed Lee at Riley House GP Surgery"
        badge="test badge"
      />
      <m-property-row
        presentation-style="vertical-line"
        label="Record Note Created on 28 Apr 2023, 14:00"
        value="Mohammed Lee at Riley House GP Surgery"
        to="#"
      />
    </m-property-list>
    <m-property-list title="Word wrapping">
      <m-property-row label="Record Note Created on 28 Apr 2023, 14:00" to="#">
        <div>
          <p>Mohammed Lee at Riley House GP Surgery</p>
          <p>
            http://www.reallylong.link/rll/X4bcO4HCL8Lh7UOAs/S_im0_O8_uQnBTjBYWT4k/qQWBBFETHMqUQ8Vq2Iuok4oebvTJQ3KUCyPsas679qva2CsY74GJWqBT0oPp0x3qDqo2hUFcO99FLM2gQ9_32tnEZRXqMGv1FLwPtYNhT083dafG9a7rWZe47HinR7SO9ieRviYDGZ_UpbOClXcz9gD11pJojMpoNPlAJR3vGeLUs1s8reaE06sZevxvA_yjQ4OK_iaXoFHjsM86NFme4KfBy5rw6rJHKuA_VpRrZJTWUBrbeWXt0Owf0gqh3RoW9naSgGm8wI_StCnqF2ELvjK3tpw7bZVEn5QaWQ9okkTdX0DfQbKlDfPl9yRx1XZkKp_O9hxAWMPnwlH2i421QOdmGF8BUnN1zcDn5ysgYxr3SYSM_QkiO31jUouDXQ
          </p>
        </div>
      </m-property-row>
    </m-property-list>
  </div>
</template>
